const IndustryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_2909_27004)">
        <path
          d="M9 13.5V9C9 8.057 9 7.586 8.707 7.293C8.414 7 7.943 7 7 7H5C4.057 7 3.586 7 3.293 7.293C3 7.586 3 8.057 3 9V18C3 19.886 3 20.828 3.586 21.414C4.172 22 5.114 22 7 22H9M9 13.5L12.317 11.842C13.417 11.292 13.967 11.016 14.394 11.199C14.4852 11.2379 14.5701 11.2901 14.646 11.354C15 11.654 15 12.269 15 13.5L18.106 11.947C19.403 11.299 20.051 10.974 20.526 11.267C21.001 11.56 21 12.286 21 13.737V18C21 19.886 21 20.828 20.414 21.414C19.828 22 18.886 22 17 22H9M9 13.5V22M3 10H9M13 2H8C7.057 2 6.586 2 6.293 2.293C6 2.586 6 3.057 6 4M16 2H17M11 5H17"
          stroke="#393D63"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2909_27004">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default IndustryIcon
